import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import { ModalContext } from 'App';
import moment from 'moment';
import CmsContext from 'context/CmsContext';
import PrintCorporationCedula from './PrintCorporationCedula';
import UpdateModal from '../components/UpdateModal';
import VerifyReceipt from './VerifyReceipt';
import RegenerateCorporationCedula from './RegenerateCorporationCedula';
import ViewORModal from '../components/ViewORModal'
import UpdateAmountModal from './UpdateAmountModal';
import Requirements from '../components/Requirements';
// import { computeCedulaInterest } from '../../helpers';
import * as action from '../action';
import * as c from '../constant';

function CorporationContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  isLoading,
  match,
  onApprove,
  taxpayer,
  onTagAsPrinted,
  taggingAsPrinted,
  approving,
  assessing,
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES')

  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;
  const permissions = getJson('permissions');

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = cString => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const cdlCorpAmts = [
    parseFloat(_.get(taxpayer, 'total_earnings_from_business')) || 0,
    parseFloat(_.get(taxpayer, 'total_assessed_value_of_real_property')) || 0,
  ];

  const cdlCorpCedulaAmt = [
    parseFloat(_.get(taxpayer, 'total_earnings_from_business_cedula')) || 0,
    parseFloat(
      _.get(taxpayer, 'total_assessed_value_of_real_property_cedula')
    ) || 0,
  ];

  const onPrintCedula = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PrintCorporationCedula data={data} id={data.id} />,
      title: 'Print Cedula Corporation',
      modalSize: 'modal-md',
    });
  };

  const computeCedulaInterest = (total, interestRate) => {
    const baseInterestRate = interestRate || 0.02;
    // const now = new Date();
    const currentMonth = moment(
      _.get(transactionInfo, 'attributes.created_at')
    ).format('MM');
    // now.getMonth() + 1;

    const monthlyInterestRate = +currentMonth * baseInterestRate;

    if (currentMonth > 2) {
      return {
        total: total * monthlyInterestRate + total,
        interest: total * monthlyInterestRate,
        interest_percentage: monthlyInterestRate,
      };
    }

    return {
      total,
      interest: 0,
      interest_percentage: 0,
    };
  };

  const totalCdlAmt = _.sum(cdlCorpAmts);
  const totalCdlCorpMax = () => {
    if (_.get(CMS_COMPONENTS, 'CEDULA_CORPORATION_TOTAL_MAX_AMOUNT')
    && _.get(CMS_COMPONENTS, 'CEDULA_CORPORATION_TOTAL_MAX_AMOUNT') < _.sum(cdlCorpCedulaAmt)) {
      return _.get(CMS_COMPONENTS, 'CEDULA_CORPORATION_TOTAL_MAX_AMOUNT') 
    }
    return _.sum(cdlCorpCedulaAmt) 
  } 
  const totalCdlCorpAmt = +totalCdlCorpMax() + 500;

  const totalWithInterest = computeCedulaInterest(
    totalCdlCorpAmt,
    +_.get(CMS_COMPONENTS, 'CEDULA_CORPORATION_BASE_INTEREST_RATE')
  );

  const serialNo =
    _.get(
      transactionInfo,
      'included.module.attributes.serial_number_complete'
    ) || 0;

  const showVerifyReceipt = status => {
    return [
      'WAITING FOR PAYMENT',
      'PAID',
      'FOR PICK-UP',
      'PENDING',
      'EXPIRED REFERENCE NUMBER',
    ].includes(status);
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={taxpayer}
          moduleId={data.attributes.module_id}
          transactId={data.id}
          validId={data.attributes.valid_id_to_present}
        />
      ),
      title: 'Update Cedula',
      modalSize: 'modal-lg',
    });
  };

  const handleVerifyReceipt = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const handleRegenerateCedula = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <RegenerateCorporationCedula data={data} id={data.id} />,
      title: 'Regenerate Corporation Cedula',
      modalSize: 'modal-md',
    });
  };

  const handleViewOR = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ViewORModal
          data={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `View OR`,
      modalSize: 'modal-lg',
    });
  };

  const updateAmount = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateAmountModal
          data={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Update Amount`,
      modalSize: 'modal-md',
    });
  };

  const tStatus = _.get(transactionInfo, 'attributes.transaction_status');
  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {getInitials(
                          `${_.get(
                            taxpayer,
                            'name_of_corporation_partnership'
                          )}`
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 mr-auto align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(
                          taxpayer,
                          'name_of_corporation_partnership'
                        ) || '-'}`}
                      </h1>
                    </div>
                  </div>
                  <div className="d-flex ml-auto mb-3 justify-content-end">
                    {_.get(transactionInfo, 'attributes.status') === 'PAID' && _.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan' ? (
                      <button
                        disabled={taggingAsPrinted || assessing}
                        type="button"
                        onClick={handleViewOR}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2"
                      >
                        {taggingAsPrinted || assessing ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            View OR
                          </>
                        )}
                      </button>
                    ) : (
                      ''
                    )}

                    {showVerifyReceipt(tStatus) && (
                      <button
                        onClick={handleVerifyReceipt}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2"
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    )}
                    {tStatus === 'PRINTED' && serialNo !== 0 ? (
                      <button
                        disabled={approving || assessing}
                        type="button"
                        onClick={onApprove(transactionInfo)}
                        className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                      >
                        {approving || assessing ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Tag as Received &nbsp;&nbsp;
                            <i className="fas fa-check" />
                          </>
                        )}
                      </button>
                    ) : (
                      ''
                    )}
                    {tStatus === 'FOR PICK-UP' && serialNo !== 0 ? (
                      <button
                        disabled={taggingAsPrinted || assessing}
                        type="button"
                        onClick={onTagAsPrinted(transactionInfo)}
                        className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                      >
                        {taggingAsPrinted || assessing ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Tag as Printed &nbsp;&nbsp;
                            <i className="fas fa-check" />
                          </>
                        )}
                      </button>
                    ) : (
                      ''
                    )}
                    &nbsp;
                    {tStatus === 'FOR PICK-UP' && serialNo === 0 ? (
                      <button
                        type="button"
                        onClick={onPrintCedula(transactionInfo)}
                        className="btn gen-btn btn-success font-weight-bold mr-2"
                      >
                        PRINT CEDULA <i className="fas fa-print" />
                      </button>
                    ) : (
                      ''
                    )}
                    {tStatus === 'FOR PICK-UP' && !_.isEmpty(serialNo) &&
                      Acl(permissions, ['REGENERATE CEDULA',])
                      ? (
                        <button
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                          onClick={handleRegenerateCedula(transactionInfo)}
                          type="button"
                        >
                          REGENERATE CEDULA
                        </button>
                      ) : (
                        ''
                      )}
                    {_.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan' &&
                      Acl(permissions, ['CEDULA CORPORATION UPDATE AMOUNT']) &&
                      _.get(transactionInfo, 'attributes.status') === 'PAID' &&
                      (['RECEIVED', 'PRINTED'].indexOf(tStatus) === -1) ? (
                        <button
                          type="button"
                          onClick={updateAmount}
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2"
                        >
                          Update Amount
                        </button>
                      ) : (
                        ''
                      )}
                  </div>

                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Information</Tab>
                      <Tab>Tax</Tab>
                      {!_.isEmpty(_.get(transactionInfo, 'included.requirementFiles')) && <Tab>Requirements</Tab>}
                    </TabList>
                    <TabPanel>  
                      <TransactionInformation
                        module="cdl"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="col-12 p-3">
                        <div className="row justify-content-end mr-2">
                          {(Acl(permissions, [
                            'VIEW CEDULA CORPORATION EDIT INFORMATION',
                          ]) && (['RECEIVED', 'PRINTED'].indexOf(tStatus) === -1))
                            &&
                            (
                              <button
                                disabled={isLoading}
                                type="button"
                                onClick={handleEdit(transactionInfo)}
                                className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                              >
                                {isLoading ? (
                                  <i className="fa fa-spin fa-spinner" />
                                ) : (
                                  <>Edit Information</>
                                )}
                              </button>
                            )}
                        </div>
                        <table className="transaction-table table table-borderless table-sm">
                          <tbody>
                            <tr>
                              <td className="text-dark" width="250">
                                President Authorized Representative:
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'president_authorized_representative'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Name of Corporation/Partnership:
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'name_of_corporation_partnership'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Address
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'region_name') || '--'}
                                  {''}
                                  {_.get(taxpayer, 'province_name') ||
                                    '--'}{' '}
                                  {_.get(taxpayer, 'municipality_name') || '--'}{' '}
                                  {_.get(taxpayer, 'barangay_name') || '--'}{' '}
                                  {_.get(taxpayer, 'street') || '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Nature of Business
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'nature_of_business_name'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Date of Registration
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'date_of_registration') ||
                                    '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Place of Registration
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'place_of_registration') ||
                                    '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                T.I.N
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>{_.get(taxpayer, 'tin') || '--'}</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="p-3">
                        <div className="full-group">
                          <div className="form-row border-bottom">
                            <div className="form-input-group col-12">
                              <label className="full-label mb-2">BASIC</label>
                            </div>
                          </div>
                          <div className="form-row border-bottom">
                            <div className="form-input-group col-6 border-right">
                              <label className="full-label mb-2 mt-2">
                                {_.get(
                                  CMS_COMPONENTS,
                                  'CEDULA_CORPORATION_DESCRIPTION_1'
                                )}
                              </label>
                            </div>
                            <div className="form-input-group col-3 border-right">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {_.get(
                                  taxpayer,
                                  'total_assessed_value_of_real_property_human'
                                ) || '--'}
                              </span>
                            </div>
                            <div className="form-input-group col-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {_.get(
                                  taxpayer,
                                  'total_assessed_value_of_real_property_cedula_human'
                                ) || '--'}
                              </span>
                            </div>
                          </div>
                          <div className="form-row border-bottom">
                            <div className="form-input-group col-6 border-right">
                              <label className="full-label mb-2 mt-2">
                                {_.get(
                                  CMS_COMPONENTS,
                                  'CEDULA_CORPORATION_DESCRIPTION_2'
                                )}
                              </label>
                            </div>
                            <div className="form-input-group col-3 border-right">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {_.get(
                                  taxpayer,
                                  'total_earnings_from_business_human'
                                ) || '--'}
                              </span>
                            </div>
                            <div className="form-input-group col-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {_.get(
                                  taxpayer,
                                  'total_earnings_from_business_cedula_human'
                                ) || '--'}
                              </span>
                            </div>
                          </div>
                          <div className="form-row border-bottom">
                            <div className="form-input-group col-6 border-right">
                              <label className="full-label mb-2 mt-2 d-flex justify-content-end">
                                Total (+{'\u20B1'}
                                {
                                  +_.get(
                                    CMS_COMPONENTS,
                                    'CEDULA_CORPORATION_BASIC_AMOUNT'
                                  )
                                }{' '}
                                Basic Amount):
                              </label>
                            </div>
                            <div className="form-input-group col-3 border-right">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {'\u20B1'}
                                {`${totalCdlAmt.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`}
                              </span>
                            </div>
                            <div className="form-input-group col-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {'\u20B1'}
                                {`${totalCdlCorpAmt.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`}
                              </span>
                            </div>
                          </div>
                          <div className="form-row border-bottom">
                            <div className="form-input-group col-6 border-right">
                              <label className="full-label mb-2 mt-2 d-flex justify-content-end">
                                Interest (
                                {totalWithInterest.interest_percentage * 100}%):
                              </label>
                            </div>
                            <div className="form-input-group col-3 border-right">
                              <span className="full-input text-right">
                                &nbsp;
                              </span>
                            </div>
                            <div className="form-input-group col-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {'\u20B1'}
                                {`${totalWithInterest.interest.toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}`}
                              </span>
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-input-group col-6 border-right">
                              <label className="full-label mb-2 mt-2 d-flex justify-content-end">
                                Total Amount Paid:
                              </label>
                            </div>
                            <div className="form-input-group col-3 border-right">
                              <span className="full-input text-right">
                                &nbsp;
                              </span>
                            </div>
                            <div className="form-input-group col-3">
                              <span className="full-input mb-2 mt-2 d-flex justify-content-end">
                                {'\u20B1'}
                                {_.get(transactionInfo, 'attributes.amount')}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    {!_.isEmpty(_.get(transactionInfo, 'included.requirementFiles')) && (
                      <TabPanel>
                        <div className="p-2">
                          <Requirements
                            data={_.get(transactionInfo, 'included.requirementFiles')}
                          />
                        </div>
                      </TabPanel>
                    )}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

CorporationContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  onApprove: PropTypes.instanceOf(Function).isRequired,
  onTagAsPrinted: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  taggingAsPrinted: PropTypes.bool.isRequired,
  assessing: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  taggingAsPrinted: api.loading.indexOf(c.TAG_AS_PRINTED_TRANSACTION) > -1,
  assessing: api.loading.indexOf(c.START_ASSESSMENT) > -1,
  approving: api.loading.indexOf(c.APPROVE_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(CorporationContent);
